/// REDUX ///
import { Dispatch } from "redux";
/// ACTIONS ///
import { Action } from "api/action_types/self_order";
/// ACTION TYPES ///
import { ActionType } from "api/action_types/self_order";
/// TYPES ///
import { IGetOrderArgs } from "api/types/order/order";

export const setSOFilter = (filter: IGetOrderArgs) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.FILTER_SELF_ORDER,
      filter
    });
  }
}
